module.exports = __webpack_public_path__ + "media/img/favicon-8dc696ebd3fa572a839507368fe4310e.ico";